<template>
  <transition name="fade" mode="out-in">
    <keep-alive :include="/Keep$/">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>

<script>
// 嵌套路由父节点必须要有一个router-view
import Device from 'utils/device'
export default {
  name: 'NestedRoutes'
}
</script>